import { render } from "./PlayerContainer.vue?vue&type=template&id=55f63a1e&scoped=true"
import script from "./PlayerContainer.vue?vue&type=script&lang=js"
export * from "./PlayerContainer.vue?vue&type=script&lang=js"

import "./PlayerContainer.vue?vue&type=style&index=0&id=55f63a1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f63a1e"]])

export default __exports__